import path from 'path';
import ReactRefreshPlugin from '@pmmmwh/react-refresh-webpack-plugin';

exports.load = (config, options) => {
  const { targets = {}, extraBabelPresets = [], extraBabelPlugins = [] } = options;
  const include = [path.resolve(process.cwd(), 'src')];

  const defaultPresets = [
    [
      '@babel/preset-env',
      {
        targets:
          options.target === 'node'
            ? {
                node: true,
              }
            : {
                chrome: 49,
                firefox: 64,
                safari: 10,
                edge: 13,
                ios: 10,
                ...targets,
              },
        useBuiltIns: false,
        debug: false,
      },
    ],
    '@babel/preset-react',
  ];

  const defaultPlugins = [
    require.resolve('babel-plugin-react-require'),
    require.resolve('@babel/plugin-syntax-dynamic-import'),
    require.resolve('@babel/plugin-proposal-object-rest-spread'),
    require.resolve('@babel/plugin-proposal-optional-catch-binding'),

    // 以下两个位置不能变动
    [
      require.resolve('@babel/plugin-proposal-decorators'),
      {
        legacy: true,
      },
    ],
    [
      require.resolve('@babel/plugin-proposal-class-properties'),
      {
        loose: true,
      },
    ],

    require.resolve('@babel/plugin-proposal-export-namespace-from'),
    require.resolve('@babel/plugin-proposal-export-default-from'),
    require.resolve('@babel/plugin-proposal-nullish-coalescing-operator'),
    require.resolve('@babel/plugin-proposal-optional-chaining'),

    [
      require.resolve('@babel/plugin-proposal-pipeline-operator'),
      {
        proposal: 'minimal',
      },
    ],
    require.resolve('@babel/plugin-proposal-do-expressions'),
    require.resolve('@babel/plugin-proposal-function-bind'),
    require.resolve('@babel/plugin-transform-destructuring'),

    require.resolve('@babel/plugin-transform-runtime'),

    ['import', { libraryName: 'antd', style: true }, 'antd'],
    ['import', { libraryName: 'td-ui', style: true }, 'td-ui'],
  ];

  const babel = {
    sourceType: 'unambiguous',
    cacheDirectory: process.env.BABEL_CACHE !== 'none',
    babelrc: !!process.env.BABELRC,
    presets: [...defaultPresets, ...extraBabelPresets],
    plugins: [...defaultPlugins, ...extraBabelPlugins].concat(
      process.env.NODE_ENV === 'development' ? require.resolve('react-refresh/babel') : [],
    ),
  };

  config.add('rule.jsx', {
    test: /\.jsx?$/,
    loader: 'babel-loader',
    include,
    options: babel,
  });

  config.add('rule.tsx', {
    test: /\.tsx?$/,
    loader: 'babel-loader',
    include,
    options: {
      ...babel,
      presets: [...babel.presets, '@babel/preset-typescript'],
    },
  });

  config.add('rule.est', {
    test: /\.est$/,
    use: ['babel-loader', 'template-string-loader'],
  });

  if (process.env.NODE_ENV === 'development') {
    config.add('plugin.ReactRefreshPlugin', new ReactRefreshPlugin());
  }
};
